import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './reconnect-setting-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReconnectSettingModalComponent implements OnInit {
    provider;

    constructor(
        private readonly matDialogRef: MatDialogRef<ReconnectSettingModalComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: { provider: string },
    ) { }

    ngOnInit(): void {
        this.provider = this.data.provider;
    }

    onReconnect(): void {
        this.matDialogRef.close(true);
    }
}
